import set from 'lodash-es/set';

var convertRowIndexPathToNumberArray = function convertRowIndexPathToNumberArray(rowIndexPath) {
  var _rowIndexPath$split$m;

  return (_rowIndexPath$split$m = rowIndexPath === null || rowIndexPath === void 0 ? void 0 : rowIndexPath.split('.').map(Number)) !== null && _rowIndexPath$split$m !== void 0 ? _rowIndexPath$split$m : [];
};
var getByRowIndexPath = function getByRowIndexPath(data, rowIndexPath) {
  if (!rowIndexPath) {
    return undefined;
  }

  var currenTRow = [].concat(data);
  var indexes = convertRowIndexPathToNumberArray(String(rowIndexPath));

  if (indexes.length) {
    var startIndex = indexes.shift();
    return indexes.reduce(function (value, index) {
      var _value$subRows;

      return value === null || value === void 0 ? void 0 : (_value$subRows = value.subRows) === null || _value$subRows === void 0 ? void 0 : _value$subRows[index];
    }, currenTRow[startIndex]);
  }

  return undefined;
};
var setByRowIndexPath = function setByRowIndexPath(data, rowIndexPath, values) {
  var nexTRow = [].concat(data);
  var rowIndexes = convertRowIndexPathToNumberArray(rowIndexPath);
  var rootIndex = rowIndexes.shift();

  if (rowIndexes.length) {
    var path = rowIndexes.map(function (index) {
      return "subRows[" + index + "]";
    }).join('.');
    set(nexTRow[rootIndex], path, values);
  } else {
    nexTRow[rootIndex] = values;
  }

  return nexTRow;
};
var getParentRowIndexPath = function getParentRowIndexPath(rowIndexPath) {
  var parentIndexPath;

  if (rowIndexPath) {
    var rowIndexes = convertRowIndexPathToNumberArray(rowIndexPath);
    rowIndexes.pop();

    if (rowIndexes.length) {
      parentIndexPath = rowIndexes.join('.');
    }
  }

  return parentIndexPath;
};

export { convertRowIndexPathToNumberArray, getByRowIndexPath, getParentRowIndexPath, setByRowIndexPath };
//# sourceMappingURL=rowIndexPath.js.map
